import { useLingui } from "@lingui/react";
import { useMemo } from "react";
import { classNames, getRegionDisplayName } from "../../utils";
import type { BaseSelectProps } from "../Select";
import { BaseSelect } from "../Select";
import type { Libphonenumber } from "./useLibPhoneNumber";

type CountrySelectProps = Omit<BaseSelectProps, "ref"> & {
	lib: Libphonenumber | null;
};

export const CountrySelect = ({ lib, value, className, disabled, ...rest }: CountrySelectProps) => {
	const { i18n } = useLingui();
	const sortedCountries = useMemo(() => {
		if (!lib) {
			return [];
		}
		return lib
			.getCountries()
			.map((code) => ({
				code,
				name: getRegionDisplayName({ code, locale: i18n.locale }),
				callingCode: lib.getCountryCallingCode(code),
			}))
			.sort((a, b) => a.name.localeCompare(b.name));
	}, [lib, i18n.locale]);

	return (
		<div className="relative w-[69px] min-w-[69px] [&>div]:h-full">
			<BaseSelect
				{...rest}
				value={value}
				disabled={disabled || !lib}
				className={classNames("rounded-r-none border-r-1", className)}
			>
				<option value="">-</option>
				{sortedCountries.map(({ code, name, callingCode }) => (
					<option key={code} value={code}>
						{name} +{callingCode}
					</option>
				))}
			</BaseSelect>
			{value && (
				<div
					className={
						"-translate-y-1/2 pointer-events-none absolute inset-y-0 top-1/2 left-3 flex max-h-[24px] items-center justify-center bg-white text-center"
					}
				>
					{value}
				</div>
			)}
		</div>
	);
};
